var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"design-disclosure"}},[(_vm.open)?_c('aside',{staticClass:"design-disclosure gl-border-l gl-relative gl-right-0 gl-top-0 gl-z-0 gl-flex gl-h-full gl-w-full gl-flex-col gl-overflow-y-auto gl-bg-default"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }